import { BorrowerPricingProcess } from './BorrowerPricingProcess';
import { MainBorrowerPricingProvider } from './contexts/main-borrower-pricing/MainBorrowerPricingProvider';

export const BorrowerPricingProcessWrapper: React.FC = () => {
  return (
    <MainBorrowerPricingProvider>
      <BorrowerPricingProcess />
    </MainBorrowerPricingProvider>
  );
};
